export { ShieldIconHypernativeTooltip, default } from './ShieldIconHypernativeTooltip'
export type { ShieldIconHypernativeTooltipProps } from './ShieldIconHypernativeTooltip'
